import { render, staticRenderFns } from "./SingleJob.vue?vue&type=template&id=17283ace&"
import script from "./SingleJob.vue?vue&type=script&lang=js&"
export * from "./SingleJob.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports